import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router } from '@angular/router';
import { UserService } from '@sharedcommon/services/user.service';

@Injectable()
export class OperatingModeGuard implements CanActivate {

  constructor(private readonly userService: UserService, private readonly router: Router) {
  }

  canActivate(route: ActivatedRouteSnapshot): boolean {
    const operatingMode = route.data['operatingMode'];
    const isValid = this.userService.getOperatingMode() === operatingMode;
    if (!isValid) {
      console.error('[OperatingModeGuard] Invalid operating mode -> redirection to home page');
      this.router.navigateByUrl('/app');
    }
    return isValid;
  }
}
